<script>
    import R, {LOADER} from "../lib/js/requests";
    import ContactPanel from "../lib/components/ContactPanel.svelte";
    import ReservationDetailsTable from "../book/ReservationDetailsTable.svelte";
    import BankPolicy from "../lib/components/BankPolicy.svelte";
    import {PAYMENT_TYPE} from "../lib/js/constants.js";

    export let hash;

    let reservation = null;

    const load = () => {
        const onSuccess = result => {
            reservation = result;
            console.log("RESERVATION", reservation);
        }

        const onFailure = err => {
        };

        R.handle(R.reservation.details, hash, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>


<section class="py-5">
    <div class="container">
        <h1 class="mb-4">Your reservation details</h1>
        {#if reservation != null}
            <div class="row">
                <div class="col-xl-7 col-lg-6 mb-4">
                    {#if reservation != null}
                        <ReservationDetailsTable {reservation}/>
                    {/if}
                </div>
                <div class="col-xl-5 col-lg-6">
                    {#if reservation.payment_type == PAYMENT_TYPE.BANK}
                        <BankPolicy/>
                    {/if}
                    <ContactPanel/>
                </div>
            </div>
        {/if}
    </div>
</section>
